// components/ProtectedRoute.js
import { Navigate, useNavigate } from "react-router-dom";
import { logoutUser } from "actions/AuthAction";
import { useEffect, useState } from "react";
import { API_ESA_OFFICE } from "utils";
import axios from "axios";

axios.defaults.withCredentials = true;

export const refreshToken = async (navigate) => {
  try {
    console.log("refresssshhhh  ");
    const response = await axios.get(API_ESA_OFFICE + "users/token", {
      credentials: "include",
    });
  } catch (error) {
    return logoutUser(navigate);
  }
};

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [shouldLogout, setShouldLogout] = useState(false);

  // refreshToken(navigate);
  // Cek sederhana apakah ada user di localStorage
  const user = localStorage.getItem("user");

  // useEffect untuk menjalankan logout jika diperlukan
  useEffect(() => {
    if (shouldLogout) {
      console.log("❌ No user found - Running logout and redirecting to login");
      logoutUser(navigate);
    }
  }, [shouldLogout, navigate]);

  // Jika tidak ada user, set flag untuk logout dan redirect ke login
  if (!user) {
    if (!shouldLogout) {
      setShouldLogout(true);
    }
    console.log("keluarrrrrr  ...");
    return <Navigate to="/authentication/sign-in/cover" replace />;
  }

  // Jika ada user, render children
  console.log("✅ User found - Rendering protected content");
  return children;
};

export default ProtectedRoute;
